/**
 * @generated SignedSource<<c65f6857dc7d5a8f8f733d340ca0627c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateTeamInput = {
  description?: string | null | undefined;
  generationDescription?: string | null | undefined;
  name: string;
};
export type CreateTeamMutation$variables = {
  input: CreateTeamInput;
};
export type CreateTeamMutation$data = {
  readonly createTeam: {
    readonly team: {
      readonly description: string | null | undefined;
      readonly id: any;
      readonly name: string;
    };
  };
};
export type CreateTeamMutation = {
  response: CreateTeamMutation$data;
  variables: CreateTeamMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTeamPayload",
    "kind": "LinkedField",
    "name": "createTeam",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLTeam",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateTeamMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateTeamMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "de885857df6fa8584e5d1f6414f13c1e",
    "id": null,
    "metadata": {},
    "name": "CreateTeamMutation",
    "operationKind": "mutation",
    "text": "mutation CreateTeamMutation(\n  $input: CreateTeamInput!\n) {\n  createTeam(input: $input) {\n    team {\n      id\n      name\n      description\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c1163d1d8da9bf6696bc62038a5d38bf";

export default node;
